module.exports = __webpack_public_path__ + "static/media/parking-man.7b0d9003.png";